export default __webpack_public_path__ + "static/media/congratsKetoLarge.96b6362f.svg";